import DeletedContent from './DeletedContent';
export default DeletedContent;
